import { RSAA } from 'redux-api-middleware'
import { getApiPath } from 'sidecar-utility-library'

import { initialState, types } from 'store/Doctor'

export const fetchDoctorFilters = () => ({
  [RSAA]: {
    endpoint: getApiPath(`doc`, `doctors/search-filters`, 'v2'),
    method: 'GET',
    types: [
      types.FETCH_DOCTOR_FILTERS_REQUEST,
      types.FETCH_DOCTOR_FILTERS_SUCCESS,
      types.FETCH_DOCTOR_FILTERS_ERROR,
    ],
  },
})

export default (state = initialState, { type, payload = {} } = {}) => {
  switch (type) {
    case types.FETCH_DOCTOR_FILTERS_REQUEST: {
      return {
        ...state,
        doctorFilters: {
          ...state.doctorFilters,
          busy: true,
          error: '',
        },
      }
    }
    case types.FETCH_DOCTOR_FILTERS_SUCCESS: {
      return {
        ...state,
        doctorFilters: {
          ...state.doctorFilters,
          busy: false,
          filters: payload,
        },
      }
    }
    case types.FETCH_DOCTOR_FILTERSNS_ERROR: {
      return {
        ...state,
        doctorFilters: {
          ...state.doctorFilters,
          busy: false,
          error: payload.response.message,
        },
      }
    }

    // ----------

    default:
      return state
  }
}
